export const Colors = () => {

  const primaryColor: string = "#201F4F", // dark blue
    secondaryColor: string = "#EB8145", // orange
    tertiaryColor: string = "#fff", // white
    fourthColor: string = "#BABAC8", // light gray 🎨
    lightestOrange: string = "#fff0e8", //lightest orange
    whiteColor: string = "#fff", // white
    dangerColor: string = "#F03738", // reddish
    warningColor: string = "#F3BB1C", // yellowish
    successColor: string = "#F03738", // greenish
    foundationColor: string = "#0D0D21", // dark blue
    grayColor: string = "#4F4F4F" // gray text color

  return (
    {
      primaryColor,
      secondaryColor,
      tertiaryColor,
      fourthColor,
      whiteColor,
      lightestOrange,
      dangerColor,
      foundationColor,
      warningColor,
      successColor, grayColor
    }
  );
};